import styled, { css } from "styled-components";

export const StyledTags = styled.div`
    ${({ customStyle }) => customStyle && customStyle};
`;

export const StyledTagsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -5px;
`;

export const StyledTagWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    height: 40px;
    margin: 5px;
    background-color: ${({ theme }) => theme.colors.steelBlue};
    border-radius: 5px;
    padding-left: 15px;
    ${({ readonly }) => readonly && css`
        padding-right: 15px;
    `};
`;

export const StyledTag = styled.div`
    ${({ theme }) => theme.fonts.openSansLight};
    font-size: 14px;
    line-height: 1;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.white};
    white-space: nowrap;
`;